// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__xz5LH","neojalogo":"Header_neojalogo__JiOuE","logotext":"Header_logotext__l+6fZ","eventcal":"Header_eventcal__HOSGf","style":"Header_style__gJPex"};